import Fields from "components/language/fields";
import { Localize } from "components/service";


const languageColumns = [
    {
        title: <Localize>TABLES.Column_Title_ID</Localize>,
        dataIndex: 'id',
        columnIndex: 'ID',
        sorter: true,
        width: '7%'
    },
    {
        title: <Localize>TABLES.Column_Title_Label</Localize>,
        dataIndex: 'label',
        columnIndex: 'LABEL',
        sorter: true,
        width: '34%'
    },
    {
        title: <Localize>TABLES.Column_Title_Slug</Localize>,
        dataIndex: 'slug',
        columnIndex: 'SLUG',
        sorter: true,
        width: '18%'
    },
    {
        title: <Localize>TABLES.Column_Title_Status</Localize>,
        dataIndex: 'status',
        columnIndex: 'STATUS',
        sorter: true,
        width: '37%'
    },
    {
        dataIndex: 'action',
        align: 'right',
        width: '4%'
    }
];

const languageData = (languages) => {
    if (!languages)
    {
        return [];
    }

    return languages.map((language) => ({
        key: language.id,
        id: language.id,
        label: <Fields.TitleLink language={ language } />,
        slug: <strong>{ language.slug }</strong>,
        status: <Fields.Status language={ language } />,
        action: <Fields.Action language={ language } />,
    }));
};

const LanguageTableHelper = {
    columns: languageColumns,
    data: languageData,
};

export default LanguageTableHelper;
